import PropTypes from 'prop-types';
import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const propTypes = {
    showBannerOnly: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
const PriceBar = renderWithRef('PriceBar`', propTypes, (props, ref)=>{
    const { showBannerOnly , children  } = props;
    const classNames = new Set([
        'swan-price-bar'
    ]);
    if (showBannerOnly) {
        classNames.add(`swan-price-bar-show-banner`);
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: classNames,
        props: props
    }, /*#__PURE__*/ React.createElement("div", {
        className: "swan-price-bar-inner"
    }, children)));
});

export { PriceBar };
